import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-terms-of-use',
  standalone: true,
  templateUrl: './terms-of-use.component.html',
  styleUrl: './terms-of-use.component.scss',
  imports: [CommonModule, RouterModule]
})
export class TermsOfUseComponent {
  readonly lastUpdated = '01.07.2026.';

  goBack(): void {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.location.href = '/';
    }
  }
}
